// extracted by css-extract-rspack-plugin
var _1 = "EjecV";
var _2 = "wBMYh";
var _3 = "YxiXc";
export { _1 as "bigHoverActionButton", _2 as "bigHoverActionContainer", _3 as "sclBigHoverActionButton" }
